import { useEffect, useState } from "react";
import DialogModal from "../UI/DialogModals";
import MaskedField from "components/UI/Fields/MaskedField";
import RadioGroupField from "components/UI/Fields/RadioGroupField";
import { ContractStore } from "store";
import { lang } from "../../i18nLang";
import useValidations from "hooks/useValidations";

const TecRetention = ({ open, onClose }) => {
  const [retention, setRetention] = useState(0);
  const [baseCalc, setBaseCalc] = useState("measurementTotal");
  const { validated, validateFields, reset, hasErrors } = useValidations({
    retention: { between: { min: 0, max: 100 } },
  });

  useEffect(() => {
    const technicalRetention =
      ContractStore.getCurrentContract()?.technicalRetention;
    const currentRetention = technicalRetention?.percentual || 0;
    const currentBase = technicalRetention?.type || "measurementTotal";

    if (currentRetention !== retention) {
      setRetention(currentRetention);
    }

    if (currentBase !== baseCalc) {
      setBaseCalc(currentBase);
    }

    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleConfirm = async () => {
    if (!validateFields({ retention }, true)) return true;
    return await ContractStore.updateTechnicalRetention(retention, baseCalc);
  };

  const handleChangeRetention = (ev) => {
    const { value } = ev.target;
    if (value !== undefined) setRetention(value);
    else setRetention(0);
  };

  const handleBlurRetention = (ev, value) => {
    validateFields({ retention: value || 0 });
  };

  const handleChangeBase = (event) => {
    setBaseCalc(event.target.value);
  };

  return (
    <DialogModal
      title={lang("retention.title")}
      open={open}
      onClose={onClose}
      confirmLabel={lang("save")}
      onConfirm={handleConfirm}
      disabledConfirm={hasErrors()}
    >
      <RadioGroupField
        name="baseCalculation"
        label={lang("retention.label2")}
        value={baseCalc}
        onChange={handleChangeBase}
        options={[
          {
            label: lang("retention.options.measurementTotal"),
            value: "measurementTotal",
          },
          {
            label: lang("retention.options.grossTotal"),
            value: "grossTotal",
          },
        ]}
      />
      <MaskedField
        name="retention"
        label={lang("retention.label") + "*"}
        suffix={"%"}
        margin="dense"
        fullWidth
        value={retention}
        onChange={handleChangeRetention}
        onBlur={handleBlurRetention}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.retention.valid}
        helperText={validated.retention.text}
      />
    </DialogModal>
  );
};

export default TecRetention;
